import { createReducer } from 'pobble-components/dist/redux-helpers'

let defaultState = {
  opened: false,
  ids: []
}

const RemoveFromGroup = createReducer(defaultState, {
  'PUPILS:REMOVE_FROM_GROUP_DIALOG:OPEN': (state, { ids }) => ({
    ...defaultState,
    opened: true,
    ids
  }),
  'PUPILS:REMOVE_FROM_GROUP_DIALOG:CLOSE': state => ({
    ...state,
    opened: false
  }),
  'PUPILS_STORE:REMOVE_PUPIL_FROM_GROUP_REQUEST': state => ({
    ...state,
    opened: false
  })
})

export default RemoveFromGroup
